module.exports = __webpack_public_path__ + "static/media/S3N3-4.93d20bd5.svg";